import { useAuth0 } from "@auth0/auth0-react";

import { Masthead } from "@/components/layout/Masthead";

const ENFORCE = (import.meta.env.VITE_AUTH0_ENFORCE ?? "true") !== "false";

export function Login() {
  const { loginWithRedirect } = useAuth0();

  const onSignIn = () => {
    if (ENFORCE) {
      loginWithRedirect({ appState: { returnTo: "/chat" } });
    } else {
      window.location.href = "/chat";
    }
  };

  return (
    <div className="min-h-screen bg-parchment-100">
      <Masthead />
      <div className="mx-auto mt-16 max-w-reading px-6 text-center">
        <span className="smallcaps text-oxblood-500">Members only</span>
        <h2 className="mt-3 font-serif text-masthead text-espresso-700">Sign in to continue</h2>
        <p className="mx-auto mt-4 max-w-md font-serif text-dek text-warmgray-500">
          Eryndal is a private compliance ledger drafted by agents and reviewed by humans.
          Sign in with your Auth0 account to access today's brief, the archive, and the regulatory library.
        </p>
        <button
          type="button"
          onClick={onSignIn}
          className="mt-10 inline-flex items-center justify-center border border-oxblood-500 bg-oxblood-500 px-8 py-3 font-serif text-base text-parchment-50 transition-colors hover:bg-oxblood-600"
        >
          Continue →
        </button>
      </div>
    </div>
  );
}
